/** Post-login destination policy for Bakeonator consoles. */

export const ACTIVE_SURFACE_KEY = 'bakeonator:activeSurface';

export const SURFACE_PLATFORM = 'platform';
export const SURFACE_PARTNER = 'partner';

export const PLATFORM_OVERVIEW_PATH = '/platform/overview';
export const PARTNER_CONSOLE_PATH = '/console';
export const PARTNER_CREATE_PATH = '/console/partners/new';

/**
 * Allow only same-origin relative paths (no open redirects).
 */
export function isSafeInternalPath(path) {
  if (!path || typeof path !== 'string') return false;
  const trimmed = path.trim();
  if (!trimmed.startsWith('/')) return false;
  if (trimmed.startsWith('//')) return false;
  if (trimmed.includes('://')) return false;
  const lower = trimmed.toLowerCase();
  if (lower.startsWith('/javascript:')) return false;
  if (lower.startsWith('/data:')) return false;
  return true;
}

function readStoredSurface() {
  try {
    const value = localStorage.getItem(ACTIVE_SURFACE_KEY);
    if (value === SURFACE_PLATFORM || value === SURFACE_PARTNER) return value;
  } catch (err) {
    // localStorage may be unavailable in some test environments.
  }
  return null;
}

/**
 * Resolve where to send the user immediately after a successful login.
 *
 * Policy:
 * 1. Safe internal returnTo when present
 * 2. Platform access, no Partner membership → Platform overview
 * 3. Platform + Partner membership → last valid surface, else Platform overview
 * 4. Partner membership only → Partner console
 * 5. Neither → Partner create/onboarding path
 */
export function resolvePostLoginDestination(session, { returnTo } = {}) {
  if (returnTo && isSafeInternalPath(returnTo)) {
    return returnTo;
  }

  const memberships = (session && session.memberships) || [];
  const hasPlatform = Boolean(session && session.has_platform_access);
  const hasPartners = memberships.length > 0;

  if (hasPlatform && !hasPartners) {
    return PLATFORM_OVERVIEW_PATH;
  }

  if (hasPlatform && hasPartners) {
    const surface = readStoredSurface();
    if (surface === SURFACE_PARTNER) {
      return PARTNER_CONSOLE_PATH;
    }
    return PLATFORM_OVERVIEW_PATH;
  }

  if (hasPartners) {
    return PARTNER_CONSOLE_PATH;
  }

  return PARTNER_CREATE_PATH;
}

export function rememberActiveSurface(surface) {
  if (surface !== SURFACE_PLATFORM && surface !== SURFACE_PARTNER) return;
  try {
    localStorage.setItem(ACTIVE_SURFACE_KEY, surface);
  } catch (err) {
    // ignore
  }
}
